import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a collection for the slice state
interface collectionState {
  name: string;
  files: string[];
  images: string[];
}

// Define the initial state using that collection
const initialState: collectionState = {
  name: "",
  files: [],
  images: [],
};

export const collectionSlice = createSlice({
  name: "collection",
  // `createSlice` will infer the state collection from the `initialState` argument
  initialState,
  reducers: {
    addcollection: (state, action) => {
      state.name = action.payload.name;
      state.files = action.payload.files ?? [];
      state.images = action.payload.images ?? [];
    },

    addImagesToCollection: (state, action) => {
      state.images = action.payload;
    },
    addFilesToCollection: (state, action) => {
      state.files = action.payload;
    },
  },
});

export const { addcollection, addImagesToCollection, addFilesToCollection } =
  collectionSlice.actions;

// Other code such as selectors can use the imported `RootState` collection

export const getcollection = (state: RootState) => state.collection;

export default collectionSlice.reducer;
